/* sm-cart.js — 2026 Design Refresh custom side cart.
   AJAX cart (add/change), slide-out drawer, Plus upsell + "do both legs" 2nd-unit nudge. */
(function () {
  'use strict';

  var CURRENCY = (window.SM_CURRENCY || 'USD');
  var fmt;
  try { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: CURRENCY }); }
  catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
  function money(cents) { return fmt.format((cents || 0) / 100); }

  var drawer, overlay, itemsEl, subtotalEl, emptyEl, footerEl, upsellEl, bothLegsEl, twoPack;

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function qs(sel, root) { return (root || document).querySelector(sel); }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function setCount(n) {
    qsa('[data-sm-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function getJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts || {}))
      .then(function (r) { return r.json(); });
  }

  function refresh() { return getJSON('/cart.js').then(render); }

  function addVariant(id, quantity) {
    return getJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ id: id, quantity: quantity || 1 }) })
      .then(function () { return refresh(); })
      .then(function () { open(); });
  }

  function changeLine(key, quantity) {
    return getJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) })
      .then(render);
  }

  // Swap a 1-Pack line for the matching-color 2-Pack: add the 2-Pack, drop the 1-Pack line.
  function upgradeToTwoPack(key, variantId) {
    return getJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ id: variantId, quantity: 1 }) })
      .then(function () { return getJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: 0 }) }); })
      .then(render)
      .then(open);
  }

  function lineItemHTML(item) {
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    return '' +
      '<div class="sm-cart__item">' +
        '<div class="sm-cart__thumb"><img src="' + (item.image || '') + '" alt="" loading="lazy"></div>' +
        '<div class="sm-cart__itemmain">' +
          '<div class="sm-cond sm-cart__itemtitle">' + item.product_title + '</div>' +
          (variant ? '<div class="sm-cart__itemvar">' + variant + '</div>' : '') +
          '<div class="sm-cart__qty">' +
            '<button type="button" class="sm-cart__qtybtn" data-sm-cart-dec="' + item.key + '" aria-label="Decrease">−</button>' +
            '<span class="sm-cond sm-cart__qtyval">' + item.quantity + '</span>' +
            '<button type="button" class="sm-cart__qtybtn" data-sm-cart-inc="' + item.key + '" aria-label="Increase">+</button>' +
            '<button type="button" class="sm-cart__remove" data-sm-cart-remove="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="sm-cond sm-cart__itemprice">' + money(item.final_line_price) + '</div>' +
      '</div>';
  }

  function render(cart) {
    setCount(cart.item_count);
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    var empty = cart.item_count === 0;
    if (emptyEl) emptyEl.hidden = !empty;
    if (footerEl) footerEl.hidden = empty;
    if (itemsEl) itemsEl.innerHTML = empty ? '' : cart.items.map(lineItemHTML).join('');

    // Upsell: hide if empty cart or the upsell product is already in the cart
    var upsellPid = upsellEl ? parseInt(upsellEl.getAttribute('data-sm-cart-upsell-pid'), 10) : 0;
    if (upsellEl) {
      var inCart = cart.items.some(function (it) { return it.product_id === upsellPid; });
      upsellEl.hidden = empty || inCart;
    }

    // "Upgrade to the 2-Pack" nudge: show when a 1-Pack Original is in cart (qty 1) and no 2-Pack yet
    if (bothLegsEl && twoPack && twoPack.productId) {
      var pid = twoPack.productId;
      var hasTwoPack = cart.items.some(function (it) { return it.product_id === pid && /2-Pack/.test(it.variant_title || ''); });
      var onePack = cart.items.filter(function (it) { return it.product_id === pid && it.quantity === 1 && /1-Pack/.test(it.variant_title || ''); })[0];
      var txtEl = bothLegsEl.querySelector('[data-sm-bothlegs-txt]');
      var color = onePack ? (onePack.variant_title || '').split('/').pop().trim() : '';
      var tp = onePack ? twoPack.twoPack[color] : null;
      if (!empty && onePack && tp && !hasTwoPack) {
        var delta = tp.price - twoPack.onePackPrice;
        bothLegsEl.setAttribute('data-key', onePack.key);
        bothLegsEl.setAttribute('data-target', tp.id);
        if (txtEl) txtEl.innerHTML = 'Upgrade to the <strong>2-Pack</strong> — do both fork legs for only <strong>' + money(delta) + '</strong> more';
        bothLegsEl.hidden = false;
      } else {
        bothLegsEl.hidden = true;
      }
    }
    return cart;
  }

  function onClick(e) {
    var t = e.target.closest('[data-sm-cart-open],[data-sm-cart-close],[data-sm-cart-inc],[data-sm-cart-dec],[data-sm-cart-remove],[data-sm-cart-bothlegs-add],[data-sm-cart-upsell-add]');
    if (!t) return;
    if (t.hasAttribute('data-sm-cart-open')) { e.preventDefault(); refresh().then(open); return; }
    if (t.hasAttribute('data-sm-cart-close')) { e.preventDefault(); close(); return; }
    if (t.hasAttribute('data-sm-cart-inc')) { bump(t.getAttribute('data-sm-cart-inc'), 1); return; }
    if (t.hasAttribute('data-sm-cart-dec')) { bump(t.getAttribute('data-sm-cart-dec'), -1); return; }
    if (t.hasAttribute('data-sm-cart-remove')) { changeLine(t.getAttribute('data-sm-cart-remove'), 0); return; }
    if (t.hasAttribute('data-sm-cart-bothlegs-add')) {
      var bl = t.closest('[data-sm-cart-bothlegs]') || bothLegsEl;
      var k = bl && bl.getAttribute('data-key');
      var target = bl && bl.getAttribute('data-target');
      if (k && target) upgradeToTwoPack(k, parseInt(target, 10));
      return;
    }
    if (t.hasAttribute('data-sm-cart-upsell-add')) {
      var vid = upsellEl && upsellEl.getAttribute('data-sm-cart-upsell-vid');
      if (vid) addVariant(parseInt(vid, 10), 1);
      return;
    }
  }

  // qty change by key needs current qty; fetch then change
  function bump(key, delta) {
    getJSON('/cart.js').then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      changeLine(key, Math.max(0, item.quantity + delta));
    });
  }
  function setQty(key, qty) { changeLine(key, qty); }

  function interceptProductForm() {
    var form = document.getElementById('sm-product-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', '');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { open(); })
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { if (btn) btn.removeAttribute('disabled'); });
    });
  }

  function init() {
    drawer = qs('[data-sm-cart]');
    overlay = qs('[data-sm-cart-overlay]');
    itemsEl = qs('[data-sm-cart-items]');
    subtotalEl = qs('[data-sm-cart-subtotal]');
    emptyEl = qs('[data-sm-cart-empty]');
    footerEl = qs('[data-sm-cart-footer]');
    upsellEl = qs('[data-sm-cart-upsell]');
    bothLegsEl = qs('[data-sm-cart-bothlegs]');
    var tpEl = qs('[data-sm-2pack]');
    try { twoPack = tpEl ? JSON.parse(tpEl.textContent) : null; } catch (e) { twoPack = null; }
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    interceptProductForm();
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
